export default "__VITE_ASSET__f79e5e79__"